import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
import Body from '../components/Body';
import Footer from '../components/Footer';
import FormContact from '../components/FormContact';

/**
 * Contact page form
 */
class ContactFormPage extends React.Component {
  static displayName = 'ContactFormPage';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @override
   */
  render() {
    return (
      <div className="ContactFormPage">
        <Navbar {...this.props} />
        <Body {...this.props}>
          <FormContact {...this.props} />
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(ContactFormPage));



// WEBPACK FOOTER //
// ./src/pages/ContactFormPage.js